export const getHubSpotContactFormUrl = (preferredLanguage, email) => {
    const emailParam = encodeURIComponent(email ?? '');
    if (preferredLanguage === 'FR') {
        return `https://4gsew.share.hsforms.com/2idn8NtT5TBqkyzpSFoqx8Q?email=${emailParam}`;
    }
    if (preferredLanguage === 'DE') {
        return `https://share.hsforms.com/1LBgZ6T3IStyU8lNqtywI_g4gsew?email=${emailParam}`;
    }
    return `https://share.hsforms.com/10jZcnqXgR-W_9-CDlcusoA4gsew?email=${emailParam}`;
};
